// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkuCarFitment_sku-car-fitment__brand__0iwyz {
  border-radius: 1rem;
  background-color: var(--gray-extra-light);
  padding: 0.8rem 3.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  margin-bottom: 3rem;
}

.SkuCarFitment_sku-car-fitment__brand-img-wrapper__VGCGJ {
  width: 6rem;
  height: 6rem;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 50%;
  background: var(--white-light);
  display: flex;
  align-items: center;
  justify-content: center;
}

.SkuCarFitment_sku-car-fitment__brand-img__3FlU2 {
  width: 5rem;
  height: 4.3rem;
  object-fit: contain;
}

.SkuCarFitment_sku-car-fitment__brand-name__KLdG6 {
  color: #000;
  font-size: var(--text-base);
  font-weight: 600;
}

.SkuCarFitment_sku-car-fitment__models-table__0Qb75 {
  margin-inline: auto;
  width: 50%;
}

.SkuCarFitment_sku-car-fitment__model-name__St98V {
  color: #000;
  font-size: var(--text-base);
  line-height: 3.6rem;
  text-align: center;
  width: 25%;
}

.SkuCarFitment_sku-car-fitment__model-year__yyr6B {
  color: var(--primary-color);
  font-size: var(--text-base);
  font-weight: 700;
  text-align: center;
  width: 20%;
}
`, "",{"version":3,"sources":["webpack://./src/components/SkuDetails/SkuCarsFitment/SkuCarFitment/SkuCarFitment.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".sku-car-fitment__brand {\n  border-radius: 1rem;\n  background-color: var(--gray-extra-light);\n  padding: 0.8rem 3.7rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n  margin-bottom: 3rem;\n}\n\n.sku-car-fitment__brand-img-wrapper {\n  width: 6rem;\n  height: 6rem;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 50%;\n  background: var(--white-light);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sku-car-fitment__brand-img {\n  width: 5rem;\n  height: 4.3rem;\n  object-fit: contain;\n}\n\n.sku-car-fitment__brand-name {\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 600;\n}\n\n.sku-car-fitment__models-table {\n  margin-inline: auto;\n  width: 50%;\n}\n\n.sku-car-fitment__model-name {\n  color: #000;\n  font-size: var(--text-base);\n  line-height: 3.6rem;\n  text-align: center;\n  width: 25%;\n}\n\n.sku-car-fitment__model-year {\n  color: var(--primary-color);\n  font-size: var(--text-base);\n  font-weight: 700;\n  text-align: center;\n  width: 20%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sku-car-fitment__brand": `SkuCarFitment_sku-car-fitment__brand__0iwyz`,
	"sku-car-fitment__brand-img-wrapper": `SkuCarFitment_sku-car-fitment__brand-img-wrapper__VGCGJ`,
	"sku-car-fitment__brand-img": `SkuCarFitment_sku-car-fitment__brand-img__3FlU2`,
	"sku-car-fitment__brand-name": `SkuCarFitment_sku-car-fitment__brand-name__KLdG6`,
	"sku-car-fitment__models-table": `SkuCarFitment_sku-car-fitment__models-table__0Qb75`,
	"sku-car-fitment__model-name": `SkuCarFitment_sku-car-fitment__model-name__St98V`,
	"sku-car-fitment__model-year": `SkuCarFitment_sku-car-fitment__model-year__yyr6B`
};
export default ___CSS_LOADER_EXPORT___;
